import { render, staticRenderFns } from "./Psychologists.vue?vue&type=template&id=221f575d"
import script from "./Psychologists.vue?vue&type=script&lang=js"
export * from "./Psychologists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports